import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Injector, Input, OnInit, Output, Signal, effect, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormGroup, FormsModule, ReactiveFormsModule, UntypedFormBuilder, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { BbsDataSet } from '../../../services/model';
import { NumbersOnlyDirective } from '../../../directives/numbers-only.diretive';
import { startWith } from 'rxjs';

type BbsDataSetHtml = BbsDataSet & {
  controlMidName: string;
};

@Component({
  selector: 'app-dynamic-table-input-bbs',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatIconModule,
    MatExpansionModule,
    NumbersOnlyDirective,
  ],
  templateUrl: './dynamic-table-input-bbs.component.html',
  styleUrl: './dynamic-table-input-bbs.component.scss',
})
export class DynamicTableInputBbsComponent implements OnInit {
  private fb: UntypedFormBuilder = inject(UntypedFormBuilder);
  @Input() title: string | undefined = '';
  @Input() data: Array<BbsDataSet> = [];
  @Input() note: string = '';
  @Input() manual: string | undefined = '';
  @Input() startTabIndex: number = 0;
  @Input() isTwoSided = true;
  @Output() inputData = new EventEmitter<{
    data: Array<BbsDataSet>;
    note: string;
    hasError: boolean;
    hasMissingInputs: boolean;
  }>(true);
  dataHtml: Array<BbsDataSetHtml> = [];
  showManual: boolean = true;
  form: FormGroup = new FormGroup({});
  private valueChanges: Signal<unknown> | undefined;
  // private formDataEffect = effect(() => {
  //   console.log('value Changes', this.valueChanges());

  //   this.inputData.emit(this.valueChanges());
  // });
  constructor(private injector: Injector) {}

  ngOnInit() {
    this.form = this.fb.group({
      ...this.data
        .flatMap(row => {
          return [{ [row.name + '_mid']: [row.value, [Validators.min(row.min ?? 0), Validators.max(row.max ?? 100)]] }];
        })
        .reduce((prev, current) => {
          const [key] = Object.keys(current);
          const value = current[key];
          prev[key] = value;
          return prev;
        }, {}),
      // note: [this.note],
    });

    this.valueChanges = toSignal(this.form.valueChanges.pipe(startWith(this.form.value)), { injector: this.injector });

    effect(
      () => {
        const formData = this.valueChanges!() as object;
        // console.log('formData valueChanges', formData);
        let hasMissingInputs = true;
        if (formData) {
          const newData: Array<BbsDataSet> = [];
          hasMissingInputs = false;
          this.data.forEach((row, zeroBasedIndex) => {
            const index = zeroBasedIndex + 1;
            const propLeft = 'test' + index + '_mid';
            const value: number | null = this.hasDynamicProperty(formData, propLeft)
              ? (formData[propLeft] as number)
              : null;
            if (value === null) {
              hasMissingInputs = true;
            }
            newData.push({
              ...row,
              value,
            });
          });
          // const note: string = this.hasDynamicProperty(formData, 'note') ? formData['note'] : '';
          const note: string = '';
          const hasError = this.form.status === 'INVALID' ? true : false;
          this.inputData.emit({ note, data: newData, hasError, hasMissingInputs });
        }
      },
      { injector: this.injector }
    );

    this.dataHtml = this.data.map(row => {
      return { ...row, controlMidName: row.name + '_mid' };
    });
  }

  hasDynamicProperty(obj: any, propName: string): obj is { [key: string]: any } {
    return typeof obj === 'object' && obj !== null && propName in obj;
  }

  // getMinMAxValue(value: number | null, row: BbsDataSet): number | null {
  //   if (row.min !== null && row.min !== undefined && row.max !== null && row.max !== undefined && value !== null) {
  //     if (value > row.max) {
  //       return row.max;
  //     } else if (value < row.min) {
  //       return row.min;
  //     } else {
  //       return value;
  //     }
  //   } else {
  //     return value;
  //   }
  // }

  // onInputChange($event: any, controlName: string, row: BbsDataSet) {
  //   // console.log('onInputChange', row);

  //   if ($event.target) {
  //     console.log('event ' + $event);

  //     if ($event.target.value === '') {
  //       return;
  //     } else {
  //       // console.log('$event.target.value', $event.target.value);
  //       $event.target.value = this.getMinMAxValue(Number($event.target.value), row);
  //       this.form.controls[controlName].patchValue(this.getMinMAxValue(Number($event.target.value), row));
  //     }
  //   }
  // }
}
